import React from 'react';
import {
  Button,
  ButtonToolbar,
  Card,
  CardBody,
  Col,
} from 'reactstrap';
import PropTypes from 'prop-types';
/* import { useTranslation } from 'react-i18next'; */
import { useForm } from 'react-hook-form';
import { emailPatter } from '../../../shared/helpers';
import { FormField } from './FormField';

const Form = ({ isHorizontal, isAboveError, handleResetPassword }) => {
  /* const { t } = useTranslation('common'); */
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  return (
    <Col md={12} lg={12} xl={6}>
      <Card>
        <CardBody>
          <form className={`form ${isHorizontal && 'form--horizontal'}`} onSubmit={handleSubmit(handleResetPassword)}>
            <div className="form__form-group">
              <span className="form__form-group-label">E-mail</span>
              <div className="form__form-group-field">
                <FormField
                  name="email"
                  control={control}
                  component="input"
                  errors={errors}
                  rules={{
                    required: 'This is required field',
                    pattern: {
                      value: emailPatter,
                      message: 'Entered value does not match email format',
                    },
                  }}
                  defaultValue=""
                  isAboveError={isAboveError}
                  placeholder="example@gmail.com"
                />
              </div>
            </div>
            <ButtonToolbar className="form__button-toolbar">
              <Button color="primary" type="submit">Reset password</Button>
              <Button
                type="button"
                onClick={() => reset({
                  username: '',
                  email: '',
                  url: '',
                  password: '',
                  select: '',
                })}
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

Form.propTypes = {
  isHorizontal: PropTypes.bool,
  isAboveError: PropTypes.bool,
};

Form.defaultProps = {
  isHorizontal: false,
  isAboveError: false,
};

export default Form;
